/** The Datadog Browser SDK session cookie. */
export const DATADOG_SESSION_COOKIE = '_dd_s_v2';

/**
 * Expires the Datadog session cookie on the current host. Used when analytics consent is withdrawn:
 * `setTrackingConsent('not-granted')` stops collection but has historically left the session cookie
 * in place, so we clear it explicitly to guarantee no Datadog cookie survives a withdrawal.
 */
export const clearDatadogCookies = (): void => {
  if (typeof document === 'undefined') {
    return;
  }
  document.cookie = `${DATADOG_SESSION_COOKIE}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/`;
};
